import { render, staticRenderFns } from "./AllCustomersList.vue?vue&type=template&id=70d310fa&"
import script from "./AllCustomersList.vue?vue&type=script&lang=js&"
export * from "./AllCustomersList.vue?vue&type=script&lang=js&"
import style0 from "./AllCustomersList.vue?vue&type=style&index=0&id=70d310fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports